import { render, staticRenderFns } from "./facebookLoginButton.vue?vue&type=template&id=df34de16&scoped=true"
import script from "./facebookLoginButton.vue?vue&type=script&lang=js"
export * from "./facebookLoginButton.vue?vue&type=script&lang=js"
import style0 from "./facebookLoginButton.vue?vue&type=style&index=0&id=df34de16&scoped=true&lang=scss"
import style1 from "./facebookLoginButton.vue?vue&type=style&index=1&id=df34de16&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df34de16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/social-login-buttons/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df34de16')) {
      api.createRecord('df34de16', component.options)
    } else {
      api.reload('df34de16', component.options)
    }
    module.hot.accept("./facebookLoginButton.vue?vue&type=template&id=df34de16&scoped=true", function () {
      api.rerender('df34de16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/facebookLoginButton.vue"
export default component.exports